<script setup lang="ts">
import type { Section } from '@/types/dynamic-layout';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import DynamicContentBlock from './DynamicContentBlock.vue';

defineProps<{
  section: Section;
}>();
</script>

<template>
  <div :class="section.className">
    <!-- Card Section -->
    <template v-if="section.type === 'card'">
      <Card>
        <CardHeader v-if="section.title">
          <CardTitle>{{ section.title }}</CardTitle>
        </CardHeader>
        <CardContent>
          <DynamicContentBlock
            v-for="content in section.content"
            :key="content.id"
            :content="content"
          />
        </CardContent>
      </Card>
    </template>

    <!-- Plain Section (no card) -->
    <template v-else-if="section.type === 'plain'">
      <div>
        <h2 v-if="section.title" class="text-xl font-semibold mb-4">
          {{ section.title }}
        </h2>
        <div>
          <DynamicContentBlock
            v-for="content in section.content"
            :key="content.id"
            :content="content"
          />
        </div>
      </div>
    </template>

    <!-- Bordered Section -->
    <template v-else-if="section.type === 'bordered'">
      <div class="border rounded-md p-4">
        <h2 v-if="section.title" class="text-xl font-semibold mb-4">
          {{ section.title }}
        </h2>
        <div>
          <DynamicContentBlock
            v-for="content in section.content"
            :key="content.id"
            :content="content"
          />
        </div>
      </div>
    </template>

    <!-- Highlighted Section -->
    <template v-else-if="section.type === 'highlighted'">
      <div class="bg-muted p-4 rounded-md">
        <h2 v-if="section.title" class="text-xl font-semibold mb-4">
          {{ section.title }}
        </h2>
        <div>
          <DynamicContentBlock
            v-for="content in section.content"
            :key="content.id"
            :content="content"
          />
        </div>
      </div>
    </template>
  </div>
</template>
